import "./PICManagement.css";

import React, { useEffect, useState } from "react";
import {
    createNewPICUser,
    findPICUsers,
    getAllBusinessUnits,
    getAllLegalEntities,
    getAllPICUsers,
    getAllSectors,
    getAllSubBusinessUnits,
    getPICByUserId,
    revokePICUser,
    updatePICUser,
} from "../../../../services/svt/svt-admin/pic-management.service";

import ConfirmationModal from "../../../common/ModalComponent/ModalComponent";
import { DataTableComponent } from "../../../common/TableComponent/DataTableComponent";
import Dropdown from "../../Dropdown/Dropdown";
import IconButton from "../../IconButton/IconButton";
import Loader from "../../../common/Loader/Loader";
import ModalComponent from "../../ModalComponent/ModalComponent";
import PlusIcon from "../../../../assets/PlusIcon";
import TableComponent from "../../TableComponent/TableComponent";
import ViewPICUserDetails from "./ViewPICUserDetails";
import { formatDate } from "../../../../utils/dateFormat";
import { getAllRoles } from "../../../../services/svt/svt-admin/rcm-management.service";
import { toast } from "react-toastify";
import validateFields from "../../../../utils/ValidationInput";
import { useTranslation, Trans } from "react-i18next";

const PICManagement = () => {
    const [loading, setLoading] = useState(true);
    const { t, i18n } = useTranslation();

    const getColumns = () => [
        { name: t("email"), field: "email", selector: row => row.email, sortable: true, width: "200px" },
        { name: t("firstName"), field: "firstName", selector: row => row.firstName, sortable: true },
        { name: t("lastName"), field: "lastName", selector: row => row.lastName, sortable: true },
        { name: t("createdDate"), field: "createdDate", selector: row => row.createdDate, sortable: true },
        { name: t("createdBy"), field: "createdBy", selector: row => row.createdBy, sortable: true },
        { name: t("comments"), field: "remarks", selector: row => row.remarks, sortable: true },
    ];

    // newLevelData as a function to update on language change
    const getNewLevelData = () => [
        { fieldName: t("firstName"), name: "firstName", fieldValue: "", type: "input", required: true },
        { fieldName: t("lastName"), name: "lastName", fieldValue: "", type: "input", required: true },
        { fieldName: t("email"), name: "email", fieldValue: "", type: "input", required: true },
        { fieldName: t("roles"), name: "roles", fieldValue: "", type: "dropdown", options: [], required: true },
        { fieldName: t("sector"), name: "sector", fieldValue: "", type: "dropdown", isFieldDisabled: false, options: [], required: true },
        { fieldName: t("bu"), name: "bu", fieldValue: "", type: "dropdown", isFieldDisabled: false, options: [], required: true },
        { fieldName: t("sUBBU"), name: "subBU", fieldValue: "", type: "dropdown", isFieldDisabled: false, options: [], required: true },
        { fieldName: t("entity"), name: "legalEntity", fieldValue: "", type: "dropdown", isFieldDisabled: false, options: [], required: true },
        { fieldName: t("comments"), name: "remarks", fieldValue: "", type: "textarea" },
    ];

    const [columns, setColumns] = useState(getColumns());
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [PICData, setPICData] = useState(getNewLevelData);
    const [tableData, setTableData] = useState([]);
    const [modalType, setModalType] = useState("");
    const [selectedRowIndex, setSelectedRowIndex] = useState("");

    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedSector, setSelectedSector] = useState("");
    const [selectedBU, setSelectedBU] = useState("");
    const [selectedSubBU, setSelectedSubBU] = useState("");
    const [selectedLegalEntity, setSelectedLegalEntity] = useState("");

    const [sectorList, setSectorList] = useState([]);
    const [BUList, setBUList] = useState([]);
    const [subBUList, setSubBUList] = useState([]);
    const [legalEntityList, setLegalEntityList] = useState([]);
    const [selectedLEDetails, setSelectedLEDetails] = useState("");
    const [selectedBUDetails, setSelectedBUDetails] = useState("");
    const [selectedSubBUDetails, setSelectedSubBUDetails] = useState("");
    const [findLEPICObj, setFindLEPICObj] = useState("");
    const [findSubBUPICObj, setFindSubBUPICObj] = useState("");
    const [findBUPICObj, setFindBUPICObj] = useState("");
    const [roleName, setRoleName] = useState("");
    const [showPICDetailsPage, setShowPICDetailsPage] = useState(false);
    const [PICUserDetailsData, setPICUserDetailsData] = useState("");
    const [isRevokeModalOpen, setIsRevokeModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState("");
    const [initialSelectedBU, setInitialSelectedBU] = useState("");
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        organizationLevel: "",
        country: "",
        region: "",
        remarks: "",
        roles: "",
        sector: "",
        bu: "",
        subBU: "",
        legalEntity: "",
    });

    useEffect(() => {
        setColumns(getColumns());
        setPICData(getNewLevelData());
        // fetchRoles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);


    useEffect(() => {
        // fetchData();
        fetchRoles(); //Used for fetching roles
        fetchSectors();
    }, []);

    useEffect(() => {
    if (selectedSector) {
        fetchBusinessUnits(selectedSector);
    }
    }, [selectedSector]);

    useEffect(() => {
    if (selectedBU) {
        fetchSelectedBUWithId(selectedBU);
    }
    }, [selectedBU]);

    useEffect(() => {
    if (selectedSubBU) {
        fetchSelectedSubBU(selectedSubBU);
        fetchLEOnCloseModal(selectedSubBU, selectedLegalEntity);
    }
    }, [selectedSubBU]);


    // useEffect(() => {
    //     if (selectedBU !== '') {
    //         if(selectedBU !== undefined) onFindPIC();
    //     }
    // }, [initialSelectedBU]);

    // Fetch all pics
    const fetchData = async () => {
        setLoading(true);
        const payload = {
            organizationId: "",
        };
        await findPICUsers(payload).then((response) => {
            const updatedData = response?.data;
            setTableData(updatedData);
            setLoading(false);
        });
    };

    // Fetch all sectors
    const fetchSectors = async () => {
        try {
            // setLoading(true);
            const sectorResult = await getAllSectors();
            const updatedData = sectorResult?.data?.map((sectorItem) => ({
                ...sectorItem,
                value: sectorItem.id,
                label: sectorItem.name,
            }));
            // fetchBusinessUnits(updatedData[0]?.id, "fetchInitialData");
            setSectorList(updatedData);
            fetchData(); // Just fetch the initial PIC data without auto-selecting
            //setSelectedSector(updatedData[0]?.id);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            // setLoading(false);
        }
    };

    // Fetch all business units
    const fetchBusinessUnits = async (sectorId, action) => {
        if (sectorId !== "") {
            try {
                setLoading(true);
                let payload = {
                    sectorId: sectorId,
                };
                const buResult = await getAllBusinessUnits(payload);
                const updatedData = buResult?.data?.map((buItem) => ({
                    ...buItem,
                    value: buItem.id,
                    label: buItem.name,
                }));
                setBUList(updatedData);
                if (updatedData.length !== 0) {
                    fetchSubBusinessUnits(updatedData[0]?.id);
                    //setSelectedBU(updatedData[0]?.id);
                    setInitialSelectedBU(updatedData[0]?.id);
                    if (action === "fetchInitialData") {
                        fetchData();
                    }
                    fetchSelectedBU(updatedData[0]?.id, updatedData);
                } else {
                    setSubBUList([]);
                    setLegalEntityList([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    // Fetch all sub business units
    const fetchSubBusinessUnits = async (buId) => {
        if (buId !== "") {
            try {
                setLoading(true);
                let payload = {
                    buId: buId,
                };
                const subbuResult = await getAllSubBusinessUnits(payload);
                const updatedSubBUData = subbuResult?.data?.map(
                    (subbuItem) => ({
                        ...subbuItem,
                        value: subbuItem.id,
                        label: subbuItem.name,
                    })
                );
                // setSelectedSubBU(updatedSubBUData[0]?.id);
                setSubBUList(updatedSubBUData);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    const fetchLegalEntities = async (subBuId) => {
        if (subBuId !== "") {
            try {
                setLoading(true);
                let payload = [subBuId];
                const LEResult = await getAllLegalEntities(payload);
                const updatedLEData = LEResult?.data?.map((subbuItem) => ({
                    ...subbuItem,
                    value: subbuItem.id,
                    label: subbuItem.name,
                }));
                // setSelectedSubBU(updatedSubBUData[0]?.id);
                setLegalEntityList(updatedLEData);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        } else {
            setLegalEntityList([]);
        }
    };

    // Fetch all roles
    const fetchRoles = async () => {
        try {
            setLoading(true);
            const rolesList = await getAllRoles();
            const filteredList = rolesList?.data?.filter(
                (item) =>
                    item.name === "PIC" ||
                    item.name === "PIC-BU" ||
                    item.name === "PIC-SUBBU"
            );
            const updatedData = PICData?.map((item) => ({
                ...item,
                options:
                    item.name === "roles"
                        ? filteredList?.map((roleItem) => ({
                              ...roleItem,
                              value: roleItem.id,
                              label: roleItem.name === 'PIC-SUBBU' ? 'PIC-SUB-BU' : roleItem.name,
                          }))
                        : item?.options,
            }));
            setPICData(updatedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchLEOnCloseModal = async (subBuId, legalEntityId) => {
        if (subBuId !== "") {
            try {
                setLoading(true);
                let payload = [subBuId];
                const LEResult = await getAllLegalEntities(payload);
                const updatedLEData = LEResult?.data?.map((subbuItem) => ({
                    ...subbuItem,
                    value: subbuItem.id,
                    label: subbuItem.name,
                }));

                let LEId = legalEntityId;
                if (typeof LEId !== "number") LEId = parseInt(LEId);
                const selectedLE = updatedLEData?.filter(
                    (item) => item.id === LEId
                );
                setFindLEPICObj(selectedLE[0]);
                setLegalEntityList(updatedLEData);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        } else {
            setLegalEntityList([]);
        }
    };

    const closeModal = () => {
    setIsModalOpen(false);

    setSelectedSector(formData.sector);
    setSelectedBU(formData.bu);
    setSelectedSubBU(formData.subBU);
    setSelectedLegalEntity(formData.legalEntity);

    setFormData({
        firstName: "",
        lastName: "",
        email: "",
        organizationLevel: "",
        country: "",
        region: "",
        remarks: "",
        roles: "",
        sector: "",
        bu: "",
        subBU: "",
        legalEntity: "",
    });
};
    // const closeModal = () => {
    //     console.log(1);
    //     setIsModalOpen(false);
    //     // Show selected values of modal in out side filters
    //     setSelectedSector(formData.sector);
    //     setSelectedBU(formData.bu);
    //     setSelectedSubBU(formData.subBU);
    //     setSelectedLegalEntity(formData.legalEntity);
    //     fetchBusinessUnits(formData.sector);
    //     if (formData.subBU !== "")
    //         fetchLEOnCloseModal(formData.subBU, formData.legalEntity);
    //     if (formData.subBU !== "") fetchSelectedSubBU(formData.subBU);
    //     if (formData.bu !== "") fetchSelectedBUWithId(formData.bu);

    //     setFormData({
    //         firstName: "",
    //         lastName: "",
    //         email: "",
    //         organizationLevel: "",
    //         country: "",
    //         region: "",
    //         remarks: "",
    //         roles: "",
    //         sector: "",
    //         bu: "",
    //         subBU: "",
    //         legalEntity: "",
    //     });
    //     setSelectedLEDetails("");
    //     setSelectedBUDetails("");
    //     setSelectedSubBUDetails("");
    //     setRoleName("");

    //     const updatedData = PICData?.map((item) => ({
    //         ...item,
    //         isFieldDisabled: false,
    //     }));
    //     setPICData(updatedData);
    // };

    const onAddNewPIC = () => {
        setIsModalOpen(true);
        setModalType("add");
        setFormData((prevData) => ({
            ...prevData,
            sector: selectedSector || "",
            bu: selectedBU || "",
            subBU: selectedSubBU || "",
            legalEntity: selectedLegalEntity || "",
        }));

        const updatedData = PICData?.map((item) => ({
            ...item,
            options:
                item.name === "sector"
                    ? sectorList?.map((obj) => ({
                          ...obj,
                          value: obj.id,
                          label: obj.name,
                      }))
                    : item.name === "bu"
                      ? BUList?.map((obj) => ({
                            ...obj,
                            value: obj.id,
                            label: obj.name,
                        }))
                        : item.name === "subBU"
                            ? subBUList?.map((obj) => ({
                                ...obj,
                                value: obj.id,
                                label: obj.name,
                            }))
                            : item.name === "legalEntity"
                                ? legalEntityList?.map((obj) => ({
                                    ...obj,
                                    value: obj.id,
                                    label: obj.name,
                                }))
                                : item?.options,
        }));
        setPICData(updatedData);
        fetchLEOnModalOpen(selectedLegalEntity, updatedData);
        fetchSubBUOnModalOpen(selectedSubBU, updatedData);
        fetchBUOnModalOpen(selectedBU, updatedData);
        // fetchModalLegalEntities(selectedSubBU);

        if (selectedBU !== "" && updatedData) {
            fetchBUOnOpenModal(selectedBU, updatedData);
        }
        // setSelectedSubBU('');
        // setSelectedLegalEntity('');
    };

    const fetchLEOnModalOpen = (value, data) => {
        if (value !== "" && value !== undefined) {
            if (typeof value !== "number") value = parseInt(value);
            const LEOption = data.filter((item) => item.name === "legalEntity");
            const selectedLE = LEOption[0]?.options?.filter(
                (item) => item.id === value
            );
            if (selectedLE && selectedLE.length > 0) {
                setSelectedLEDetails(selectedLE[0]);
            }
        }
    };
    const fetchSubBUOnModalOpen = (value, data) => {
        if (value !== "" && value !== undefined) {
            if (typeof value !== "number") value = parseInt(value);
            const SubBUOption = data.filter((item) => item.name === "subBU");
            const selectedSubBUObj = SubBUOption[0]?.options?.filter(
                (item) => item.id === value
            );
            if (selectedSubBUObj && selectedSubBUObj.length > 0) {
                setSelectedSubBUDetails(selectedSubBUObj[0]);
            }
        }
    };
    const fetchBUOnModalOpen = (value, data) => {
        if (value !== "" && value !== undefined) {
            if (typeof value !== "number") value = parseInt(value);
            const BUOption = data.filter((item) => item.name === "bu");
            const selectedBUObj = BUOption[0]?.options?.filter(
                (item) => item.id === value
            );
            if (selectedBUObj && selectedBUObj.length > 0) {
                fetchSubBusinessUnits(selectedBUObj[0].id);
                setSelectedBUDetails(selectedBUObj[0]);
            }
        }
    };

    const fetchSubBuOptions = async (val) => {
        try {
            setLoading(true);
            let payload = { buId: val };
            const subbuResult = await getAllSubBusinessUnits(payload);

            // fetchModalLegalEntities(buResult, subbuResult);
            const updatedData = PICData?.map((item) => ({
                ...item,
                options:
                    item.name === "subBU"
                        ? subbuResult?.data?.map((obj) => ({
                              ...obj,
                              value: obj.id,
                              label: obj.name,
                          }))
                        : item.name === "legalEntity"
                          ? []
                          : item?.options,
            }));
            setPICData(updatedData);
            // fetchBUOnOpenModal(buResult?.data[0]?.id, updatedData)
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    const onChangeInput = (inputData, label) => {
        const { name, value } = inputData;
        toast.dismiss();
        if (name === "firstName" && value.length > 30) {
            toast.error(t("firstNameCannotExceed", { number: 30 }), {
                position: "top-center",
            });
            return;
        }
        if (name === "lastName" && value.length > 30) {
            toast.error(t("lastNameCannotExceed", { number: 30 }), {
                position: "top-center",
            });
            return;
        }
        if (name === "remarks" && value.length > 255) {
            toast.error("Comments cannot exceed 255 characters.", {
                position: "top-center",
            });
            return;
        }
 
        if (name === "sector") {
            fetchModalBusinessUnits(value);
        }
        if (name === "subBU") {
            if (value === "" || value === undefined) {
                // Reset legal entity when sub BU is cleared
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: value,
                    legalEntity: "",
                }));
                setSelectedLEDetails("");
                const updatedData = PICData?.map((item) => ({
                    ...item,
                    options: item.name === "legalEntity" ? [] : item?.options,
                }));
                setPICData(updatedData);
            } else {
                fetchModalLegalEntities(value);
                fetchSubBUDetails(value);
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: value,
                }));
            }
            return;
        }
        if (name === "bu") {
            fetchSubBuOptions(value);
            fetchBUDetails(value);
        }
        if (name === "legalEntity") {
            fetchLEDetails(value);
        }
 
        // Select Roles
        if (name === "roles") {
            setRoleName(label);
            if (label === "PIC-BU") {
                const updatedData = PICData?.map((item) => ({
                    ...item,
                    isFieldDisabled:
                        item.name === "subBU" || item.name === "legalEntity"
                            ? true
                            : item?.isFieldDisabled,
                    options: item.name === "legalEntity" ? [] : item?.options,
                }));
                setFormData((prevData) => ({
                    ...prevData,
                    sector: selectedSector,
                    bu: selectedBU,
                    subBU: "",
                    legalEntity: "",
                }));
                setPICData(updatedData);
                setSelectedLEDetails("");
                setSelectedSubBUDetails("");
            } else if (label === "PIC-SUB-BU") {
                const updatedData = PICData?.map((item) => ({
                    ...item,
                    isFieldDisabled:
                        item.name === "legalEntity"
                            ? true
                            : item.name === "subBU"
                                ? false
                                : item?.isFieldDisabled,
                }));
                setPICData(updatedData);
                setFormData((prevData) => ({
                    ...prevData,
                    sector: selectedSector,
                    bu: selectedBU,
                    subBU: selectedSubBU,
                    legalEntity: "",
                }));
                setSelectedLEDetails("");
            } else {
                const updatedData = PICData?.map((item) => ({
                    ...item,
                    isFieldDisabled:
                        item.name === "legalEntity"
                            ? false
                            : item.name === "subBU"
                                ? false
                                : item?.isFieldDisabled,
                }));
                setPICData(updatedData);
            }
        }
 
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const fetchLEDetails = (value) => {
        if (value !== "") {
            if (typeof value !== "number") value = parseInt(value);
            const LEOption = PICData.filter(
                (item) => item.name === "legalEntity"
            );
            const selectedLE = LEOption[0]?.options?.filter(
                (item) => item.id === value
            );
            setSelectedLEDetails(selectedLE[0]);
        } else {
            setSelectedLEDetails("");
        }
    };
    const fetchSubBUDetails = (value) => {
        if (typeof value !== "number") value = parseInt(value);
        const SubBUOption = PICData.filter((item) => item.name === "subBU");
        const selectedSubBUObj = SubBUOption[0]?.options?.filter(
            (item) => item.id === value
        );
        setSelectedSubBUDetails(selectedSubBUObj[0]);
    };
    const fetchBUDetails = (value) => {
        if (typeof value !== "number") value = parseInt(value);
        const BUOption = PICData.filter((item) => item.name === "bu");
        const selectedBUObj = BUOption[0]?.options?.filter(
            (item) => item.id === value
        );
        fetchSubBusinessUnits(selectedBUObj[0].id);
        setSelectedBUDetails(selectedBUObj[0]);
    };

    const fetchBUOnOpenModal = (value, data) => {
        let updatedlist;
        if (data) updatedlist = data;
        else updatedlist = PICData;
        const BUOption = updatedlist.filter((item) => item.name === "bu");

        if (typeof value !== "number") value = parseInt(value);

        const selectedBUObj = BUOption[0]?.options?.filter(
            (item) => item.id === value
        );
        setSelectedBUDetails(selectedBUObj[0]);
    };

    const fetchModalBusinessUnits = async (sectorId) => {
        try {
            setLoading(true);
            let payload = { sectorId: sectorId };
            const buResult = await getAllBusinessUnits(payload);
            setFormData((prevData) => ({
                ...prevData,
                sector: sectorId,
                bu: buResult?.data.length !== 0 && buResult?.data[0].id,
                subBU: "",
                legalEntity: "",
            }));
            fetchModalSubBusinessUnits(buResult);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchModalSubBusinessUnits = async (buResult) => {
        if (buResult?.data.length !== 0) {
            try {
                setLoading(true);
                let payload = { buId: buResult?.data[0]?.id };
                const subbuResult = await getAllSubBusinessUnits(payload);

                // fetchModalLegalEntities(buResult, subbuResult);
                const updatedData = PICData?.map((item) => ({
                    ...item,
                    options:
                        item.name === "bu"
                            ? buResult?.data?.map((obj) => ({
                                  ...obj,
                                  value: obj.id,
                                  label: obj.name,
                              }))
                            : item.name === "subBU"
                              ? subbuResult?.data?.map((obj) => ({
                                    ...obj,
                                    value: obj.id,
                                    label: obj.name,
                                }))
                              : item.name === "legalEntity"
                                ? []
                                : item?.options,
                }));
                setPICData(updatedData);
                fetchBUOnOpenModal(buResult?.data[0]?.id, updatedData);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        } else {
            const updatedData = PICData?.map((item) => ({
                ...item,
                options:
                    item.name === "bu"
                        ? []
                        : item.name === "subBU"
                          ? []
                          : item?.options,
            }));
            setPICData(updatedData);
        }
    };

    const fetchModalLegalEntities = async (subbuId) => {
        if (subbuId !== "") {
            try {
                setLoading(true);
                let payload = [subbuId];
                const leResult = await getAllLegalEntities(payload);

                const updatedData = PICData?.map((item) => ({
                    ...item,
                    options:
                        item.name === "legalEntity"
                            ? leResult?.data?.map((obj) => ({
                                  ...obj,
                                  value: obj.id,
                                  label: obj.name,
                              }))
                            : item?.options,
                }));
                setPICData(updatedData);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    const trimText = (text) => {
        return text.trim().replace(/\s+/g, " ");
    };

    const saveData = async () => {
        let roleIddetails = {
            organizationId: "",
            tierId: "",
        };
        if (roleName === "PIC-BU") {
            roleIddetails.organizationId = selectedBUDetails?.id;
            roleIddetails.tierId = selectedBUDetails?.tierId;
        } else if (roleName === "PIC-SUB-BU") {
            roleIddetails.organizationId = selectedSubBUDetails?.id;
            roleIddetails.tierId = selectedSubBUDetails?.tierId;
        } else {
            roleIddetails.organizationId = selectedLEDetails?.id;
            roleIddetails.tierId = selectedLEDetails?.tierId;
        }

        setLoading(true);
        // Required fields with types (text or email)
        let requiredFields = [
            {
                label: t("firstName"),
                key: "First Name",
                type: "text",
                value: trimText(formData.firstName),
            },
            {
                label: t("lastName"),
                key: "Last Name",
                type: "text",
                value: trimText(formData.lastName),
            },
            {
                label: t("email"),
                key: "Email",
                type: "email",
                value: trimText(formData.email),
                // charLength: 100,
            },
            { label: t("roles"), key: "Roles", type: "dropdown", value: formData.roles },
            { label: t("sector"), key: "Sector", type: "dropdown", value: formData.sector },
            { label: t("bu"), key: "BU", type: "dropdown", value: formData.bu },
        ];
        const newFields = [
            { label: t("subBu"), key: "SUB BU", type: "dropdown", value: formData.subBU },
            { label: t("entity"), key: "Entity", type: "dropdown", value: formData.legalEntity },
        ];
        if (roleName === "PIC") {
            requiredFields = [...requiredFields, ...newFields];
        }
        if (roleName === "PIC-SUBBU" || roleName === "PIC-SUB-BU") {
            requiredFields = [
                ...requiredFields,
                ...[{ label: t("subBu"), key: "SUB BU", type: "dropdown", value: formData.subBU }],
            ];
        }

        const isValid = validateFields(formData, requiredFields, "byValue");
        if (!isValid) {
            setLoading(false);
            return;
        }

        let payload = {
            firstName: trimText(formData.firstName),
            lastName: trimText(formData.lastName),
            emailId: trimText(formData.email),
            organizationId: roleIddetails.organizationId,
            roleId: formData.roles,
            tierId: roleIddetails.tierId,
            remarks: formData.remarks,
        };
        const response = await createNewPICUser(payload);
            if (response === null) {
                setLoading(false);
            } else {
                // fetchData();
                onFindPIC();
                closeModal();
                setLoading(false);
            }
      };

    const updateData = async () => {
        setLoading(true);
        let payload = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            emailId: formData.email,
            organizationId: formData.organizationLevel,
            roleId: formData.roles,
            // tierId: formData.tierId,
            remarks: formData.remarks,
        };
        await updatePICUser(payload).then((response) => {
            if (response === null) {
                setLoading(false);
            } else {
                // fetchData();
                closeModal();
                setLoading(false);
            }
        });
    };

    const onEditDetails = (data, selectedIndex) => {
        setModalType("edit");
        setIsModalOpen(true);
        setSelectedRowIndex(selectedIndex);

        let {
            firstName,
            lastName,
            email,
            organizationLevel,
            country,
            region,
            remarks,
            sector,
        } = data;
        setFormData({
            firstName: firstName,
            lastName: lastName,
            email: email,
            organizationLevel: organizationLevel,
            country: country,
            region: region,
            remarks: remarks,
            sector: "",
            bu: "",
            subBU: "",
            legalEntity: "",
        });
    };

    const onChangeDropdownVal = (e) => {
        const { name, value } = e.target;
        if (name === "country") setSelectedCountry(value);
        else if (name === "sector") {
            setSelectedSector(value);
            fetchBusinessUnits(e.target.value);
            setLegalEntityList([]); //After selection of sector legal entity will get reset
            setSelectedLegalEntity("");
            if (e.target.value === "") {
                setSelectedBU("");
                setSelectedSubBU("");
                setSubBUList([]);
                setBUList([]);
            }
        } else if (name === "buList") {
            setSelectedBU(value);
            fetchSubBusinessUnits(e.target.value);
            fetchSelectedBUWithId(value);
            setLegalEntityList([]); //After selection of bu legal entity will get reset
            setSelectedLegalEntity("");
            setSelectedSubBU("");
            if (e.target.value === "") {
                setSelectedSubBU("");
                setSubBUList([]);
            }
        } else if (name === "subBuList") {
            setSelectedSubBU(value);
            fetchLegalEntities(e.target.value);
            fetchSelectedSubBU(value);
            fetchModalLegalEntities(value);
        } else if (name === "legalEntity") {
            setSelectedLegalEntity(value);
            fetchSelectedLE(value);
        }
    };

    const onFindPIC = async () => {
        let roleIddetails = {
            organizationId: "",
            // tierId: "",
        };
        if (
            selectedSector === "" &&
            selectedBU === "" &&
            selectedSubBU === "" &&
            selectedLegalEntity === ""
        ) {
            roleIddetails.organizationId = "";
        } else {
            if (
                selectedBU === "" &&
                selectedSubBU === "" &&
                selectedLegalEntity === ""
            ) {
                roleIddetails.organizationId = selectedSector;
                // roleIddetails.tierId = selectedSector;
            } else if (selectedSubBU === "" && selectedLegalEntity === "") {
                roleIddetails.organizationId = findBUPICObj.id;
                // roleIddetails.tierId = findBUPICObj.tierId;
            } else if (selectedLegalEntity === "") {
                roleIddetails.organizationId = findSubBUPICObj.id;
                // roleIddetails.tierId = findSubBUPICObj.tierId;
            } else {
                roleIddetails.organizationId = findLEPICObj.id;
                // roleIddetails.tierId = findLEPICObj.tierId;
            }
        }

        setLoading(true);
        const payload = {
            // tierId: roleIddetails.tierId,
            organizationId: roleIddetails.organizationId,
        };
        await findPICUsers(payload).then((response) => {
            const updatedData = response?.data;
            setTableData(updatedData);
            setLoading(false);
        });
    };

    const onRevokeUser = () => {
        let payload = {
            organizationId: selectedUser.organizationId,
            userId: selectedUser.id,
            roleId: selectedUser.roleId,
        };
        revokePICUser(payload).then((response) => {
            if (response !== null) {
                    toast.success(t("successfullyRevokedPICRole", { email: selectedUser?.email }), {
                        position: "top-center"
                    });
            }
            // fetchData();
            onFindPIC();
            setShowPICDetailsPage(false);
            setIsRevokeModalOpen(false);
            setSelectedUser("");
        });
    };

    const fetchSelectedLE = (value) => {
        if (typeof value !== "number") value = parseInt(value);
        const selectedLE = legalEntityList?.filter((item) => item.id === value);
        setFindLEPICObj(selectedLE[0]);
    };
    const fetchSelectedSubBU = (value) => {
        if (typeof value !== "number") value = parseInt(value);
        const selectedSubBUObj = subBUList?.filter((item) => item.id === value);
        setFindSubBUPICObj(selectedSubBUObj[0]);
    };
    const fetchSelectedBU = (value, data) => {
        if (typeof value !== "number") value = parseInt(value);
        const selectedBUObj = data?.filter((item) => item.id === value);
        setFindBUPICObj(selectedBUObj[0]);
    };

    const fetchSelectedBUWithId = (value) => {
        if (typeof value !== "number") value = parseInt(value);
        const selectedBUObj = BUList?.filter((item) => item.id === value);
        setFindBUPICObj(selectedBUObj[0]);
    };

    const onViewPICDetails = (data, selectedIndex) => {
        setPICUserDetailsData(data);
        setShowPICDetailsPage(true);
    };
    const onCloseViewPICDetails = () => {
        setShowPICDetailsPage(false);
    };
    // Handle Open Revoke Modal
    const handleOpenRevokeModal = (row) => {
        setSelectedUser(row);
        setIsRevokeModalOpen(true);
    };
    // Cancel Revoke
    const handleCancelRevoke = () => {
        setIsRevokeModalOpen(false);
        setSelectedUser("");
    };

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className={["glbOuterWrapper", "picMgmt"].join(" ")}>
                    {!showPICDetailsPage ? (
                        <>
                            {/* Top Filter Bar For PIC */}
                            <div className="picSearchBarOuterDiv">
                                <div className="picSearchBar">
                                    <div className="searchDropdown">
                                        <div className="dropdownLabel">{t("sector")}</div>
                                        <Dropdown
                                            value={selectedSector}
                                            handelChangeInput={onChangeDropdownVal}
                                            options={sectorList}
                                            name="sector"
                                            defaultLabel={t("selectSector")}
                                            isLabelDisabled={false}
                                        />
                                    </div>
                                    <div className="searchDropdown">
                                        <div className="dropdownLabel">{t("bu")}</div>
                                        <Dropdown
                                            value={selectedBU}
                                            handelChangeInput={onChangeDropdownVal}
                                            options={BUList}
                                            name="buList"
                                            defaultLabel={t("selectBU")}
                                            isLabelDisabled={false}
                                        />
                                    </div>
                                </div>

                                <div className="picSearchBar">
                                    <div className="searchDropdown">
                                        <div className="dropdownLabel">{t("subBU")}</div>
                                        <Dropdown
                                            value={selectedSubBU}
                                            handelChangeInput={onChangeDropdownVal}
                                            options={subBUList}
                                            name="subBuList"
                                            defaultLabel={t("selectSubBU")}
                                            isLabelDisabled={false}
                                        />
                                    </div>
                                    <div className="searchDropdown">
                                        <div className="dropdownLabel">{t("entity")}</div>
                                        <Dropdown
                                            value={selectedLegalEntity}
                                            handelChangeInput={onChangeDropdownVal}
                                            options={legalEntityList}
                                            name="legalEntity"
                                            defaultLabel={t("selectEntity")}
                                            isLabelDisabled={false}
                                        />
                                    </div>
                                </div>

                                <div className="picButtonOuterDiv">
                                    <div>
                                        <IconButton
                                            text={t("findPIC")}
                                            onClick={onFindPIC}
                                            style={{
                                                backgroundColor: "#F0F0F0",
                                                color: "#454647",
                                                border: "1px solid #B3B2B4",
                                            }}
                                            icon=""
                                        />
                                    </div>
                                    <IconButton
                                        text={t("addPIC")}
                                        onClick={onAddNewPIC}
                                        style={{
                                            backgroundColor: "#F0F0F0",
                                            color: "#454647",
                                            border: "1px solid #B3B2B4",
                                        }}
                                        icon={<PlusIcon />}
                                    />
                                </div>
                            </div>

                            <div style={{ marginTop: "1rem" }}>
                                <DataTableComponent
                                    columns={columns}
                                    data={tableData}
                                    // onRevokeUser={onRevokeUser}
                                    tableName="pic"
                                    noDataMessage={t("noDataFound") || "No Data Found"}
                                    onEditDetails={onEditDetails}
                                    onViewPICDetails={onViewPICDetails}
                                    pageCount={5}
                                />
                            </div>

                            <ModalComponent
                                modalTitle={modalType === "add" ? t("addPIC") : t("editPIC")}
                                isOpen={isModalOpen}
                                fieldsData={PICData}
                                formData={formData}
                                modalType={modalType}
                                onClose={closeModal}
                                onChangeInput={onChangeInput}
                                buttons={[
                                    <button
                                        className="saveButton"
                                        onClick={modalType === "add" ? saveData : updateData}
                                    >
                                        {modalType === "add" ? t("add") : t("update")}
                                    </button>,
                                    <button className="cancelButton" onClick={closeModal}>
                                        {t("cancel")}
                                    </button>,
                                ]}
                            />
                        </>
                    ) : (
                        <ViewPICUserDetails
                            onCloseViewPICDetails={onCloseViewPICDetails}
                            data={PICUserDetailsData}
                            onRevokeUser={handleOpenRevokeModal}
                        />
                    )}

                    {/* Revoke Confirmation Modal */}
                    <ConfirmationModal
                        isOpen={isRevokeModalOpen}
                        onClose={handleCancelRevoke}
                        modalTitle={t("revokeUser")}
                        modalText={
                            <p>
                                <Trans
                                    i18nKey="areYouSureRevokePIC"
                                    values={{ email: selectedUser?.email }}
                                    components={{ b: <b /> }}
                                />
                            </p>
                        }
                        buttons={[
                            <button
                                key="revoke"
                                className="survey-upload-btn"
                                onClick={onRevokeUser}
                            >
                                {t("revoke")}
                            </button>,
                            <button
                                key="cancel"
                                className="survey-cancel-btn"
                                onClick={handleCancelRevoke}
                            >
                                {t("cancel")}
                            </button>,
                        ]}
                    />
                </div>
            )}
        </>
    );
};

export default PICManagement;
